/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backgrid from 'backgrid';

import './ButtonLinkCell.css';
import tmplButtonLinkCell from './ButtonLinkCell.hbs';

const ButtonCell = Backgrid.Cell.extend({
  className: 'link-button-cell td-grid-cell-btn',

  render() {
    let href = '#';
    if (this.href) {
      href = Backgrid.callByNeed(this.href, this, this.model);
    }

    let buttonClass = 'btn-primary';
    if (this.buttonClass) {
      buttonClass = Backgrid.callByNeed(this.buttonClass, this, this.model);
    }

    this.$el.addClass(this.column.get('name'));

    let isRenderable = true;
    if (this.renderable) {
      isRenderable = Backgrid.callByNeed(this.renderable, this, this.model);
    }

    if (isRenderable) {
      this.$el.empty().append(
        tmplButtonLinkCell({
          name: this.name,
          newTab: this.newTab,
          href,
          buttonClass
        })
      );
      this.delegateEvents();
      return this;
    }
  },

  onClickOfLink(e) {
    if (this.onClick && _.isFunction(this.onClick)) {
      e.preventDefault();
      this.onClick(this.model);
    }
  }
});

export default ButtonCell;
